import React, { useMemo } from 'react';
import { PropTypes } from 'prop-types';
import { useTranslation } from 'react-i18next';
import Tag from 'components/Tag';
import LiteralCurrency from 'components/LiteralCurrency';
import { GirdedQuestionIcon, GirdedInfoIcon } from 'refactored/ui/icons';

const ESTIMATION_PRICE_PERCENTAGE = 50;

const NonFeasibleEstimationMessage = ({ className, price, toggleDropdown }) => {
  const { t } = useTranslation('Communications');
  const total = Number(price);

  const range = useMemo(
    () => ({
      from: total,
      to: total + (ESTIMATION_PRICE_PERCENTAGE * total) / 100,
    }),
    [total]
  );

  return (
    <div className={className} data-testid="non-feasible-estimation-message">
      <div>
        <span className="non-feasible-estimation-title">
          {t('feasibility.estimation_message.shipment_price')}
        </span>
        <Tag>
          <span>{t('feasibility.estimation_message.estimation')}</span>
          <GirdedInfoIcon />
        </Tag>
        <span className="price-range">
          <LiteralCurrency value={range.from} />
          <span> - </span>
          <LiteralCurrency value={range.to} />
          <GirdedQuestionIcon onClick={toggleDropdown} />
        </span>
      </div>
      <p className="extra-info">*{t('feasibility.estimation_message.extra')}</p>
    </div>
  );
};

NonFeasibleEstimationMessage.propTypes = {
  className: PropTypes.string,
  price: PropTypes.number,
  toggleDropdown: PropTypes.func,
};

export default NonFeasibleEstimationMessage;
